import "assets/scss/pages/home.scss";

import { Box, Container, Grid, Stack } from "@mui/material";
import { Common, Custom, FormGuest } from "components";
import { useApp, useParameter, useTheme } from "contexts";
import { Helpers } from "utils";
import { AuthParamType } from "types";

type Props = {};

export const UserGuestOnboarding = (props: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const { params } = useParameter<AuthParamType>();

  return (
    <Box pt={theme.spacing.xl}>
      <Stack gap={theme.spacing.xxl}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={4}>
              <Box>
                <Stack spacing={theme.spacing.sm}>
                  <Custom.Typography
                    size={theme.font.lg}
                    weight={theme.font.bold}
                  >
                    {t.message.greeting.hi}
                  </Custom.Typography>
                  <Common.Image src={Helpers.getImage("homepage_banner.png")} />
                  <Box
                    sx={{
                      border: 1,
                      overflow: "hidden",
                      mt: theme.spacing.md,
                      px: theme.spacing.lg,
                      pt: theme.spacing.lg,
                      pb: theme.spacing.xxl,
                      borderRadius: theme.border.radius,
                      borderColor: theme.color.primary.accent,
                    }}
                  >
                    <Stack spacing={theme.spacing.sm}>
                      <Box>
                        <Custom.Typography size={theme.font.xs}>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Quisque in mi mattis, lobortis erat lacinia,
                          egestas sem. Etiam pellentesque viverra nibh non
                          pulvinar.
                        </Custom.Typography>
                      </Box>
                      <FormGuest.Form
                        email={params.email}
                        redirect={params.redirect}
                      />
                    </Stack>
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              sx={{ display: { sm: "none", md: "unset" } }}
            >
              <Common.Image src={Helpers.getImage("homepage_art.png")} />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </Box>
  );
};
